import { render, staticRenderFns } from "./ProjectEditorHeaderTabTag.vue?vue&type=template&id=1ba1c010"
import script from "./ProjectEditorHeaderTabTag.vue?vue&type=script&lang=ts"
export * from "./ProjectEditorHeaderTabTag.vue?vue&type=script&lang=ts"
import style0 from "./ProjectEditorHeaderTabTag.vue?vue&type=style&index=0&id=1ba1c010&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports